export interface ETLDataImpotObj {
    FeedName: string;
    ImportID: string;
    ImportName: string;
    DateAdded: string;
    NumberOfRecords: number;
}

export interface RawDataDefination {
    // As of now we dont know actual data. we will change after once API is available
    [key: string]: any;
}

export interface CustomerImportList {
    ImportHistory: ETLDataImpotObj[];
    RawDataDefinitions: RawDataDefination[];
}

export const PERMISSION = {
    VIEW: "VIEW",
    CREATE: "CREATE"
}